import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { RowDivider } from '../UserProfileStyles';
import UserProfileChangePassword from './UserProfileChangePassword';

type UserProfileInfoProps = {
  displayFirstName: string;
  displayLastName: string;
  displayUserName: string;
  isPrimaryUser: boolean;
  isIncentiveAdvantageType: boolean;
  showChangePassword: boolean;
  showChangePasswordToggle: () => void;
};

const UserProfileInfo: FC<UserProfileInfoProps> = (props) => {
  const {
    displayFirstName,
    displayLastName,
    displayUserName,
    isPrimaryUser,
    isIncentiveAdvantageType,
    showChangePassword,
    showChangePasswordToggle,
  } = props;
  const { isMobileDevice, isTabletDevice } = useCheckDevice();
  return (
    <RowDivider
      borderColor={isMobileDevice ? theme.palette.backgroundGray : theme.palette.lightGreySix}
    >
      <div className={`col-sm-8 ${isTabletDevice ? 'text-wrapper' : ''}`}>
        <UserAvatarWrapper>
          <img
            src='https://storage.googleapis.com/customer-images-prd/socialmedia/avatar-incognito.svg'
            alt='Default Avatar'
          />
        </UserAvatarWrapper>
        <NameEmailWrapper>
          <TextWrapper fontSize={theme.typography.h3}>
            <b>{`${displayFirstName} ${displayLastName}`}</b>
          </TextWrapper>
          <TextWrapper>{displayUserName}</TextWrapper>
        </NameEmailWrapper>
      </div>
      {!isMobileDevice && (
        <div className={`col-sm-4 ${isTabletDevice ? 'button-wrapper' : ''}`}>
          <ActionWrapper>
            <UserProfileChangePassword
              isIncentiveAdvantageType={isIncentiveAdvantageType}
              isPrimaryUser={isPrimaryUser}
              showChangePassword={showChangePassword}
              showChangePasswordToggle={showChangePasswordToggle}
            />
          </ActionWrapper>
        </div>
      )}
    </RowDivider>
  );
};

export default UserProfileInfo;

const NameEmailWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

type TextWrapperProps = {
  fontSize?: number;
};
const TextWrapper = styled.p<TextWrapperProps>`
  font-size: ${(props) => (props.fontSize ? props.fontSize : theme.typography.fontSize16)}px;
  margin: auto;
`;

const UserAvatarWrapper = styled.div`
  background-color: ${theme.palette.lightGray};
  width: 78px;
  height: 78px;
  border-radius: 100px;
  margin: 0 10px 15px 0;
  display: inline-block;
  text-align: center;
`;

const ActionWrapper = styled.div`
  text-align: right;
  position: absolute;
`;
